
export const dashboardManager = {
  namespaced: true,
  state: {
    processSearch: null,
    facilitySearch: null
  },
  mutations: {
    storeManagerProcessSearch(state, search) {
      state.processSearch = search;     
    },
    storeFacilitySearch(state, search) {
      state.facilitySearch = search;
    }
  }
}
